var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FoldingCard',{attrs:{"title":"System Information","items":_vm.systemInfoCard,"unFolding":_vm.unFolding}})}
var staticRenderFns = []

export { render, staticRenderFns }